import { Card, CardContent, Typography } from '@growdash/design-system/atoms';
import React from 'react';

type Props = {
  title: string;
  icon: (params?: any) => React.ReactNode;
  value: string | number | undefined | null;
};

export default function BrandOverviewCard({ icon, title, value }: Props) {
  return (
    <Card className="max-h-full lg:h-min ">
      <CardContent className="flex flex-col">
        <div className="flex items-center gap-2">
          {icon({})}
          <Typography className="text-xs font-semibold text-tertiary">
            {title}
          </Typography>
        </div>
        <div className="h-[1.875rem] flex items-center mt-2">
          <Typography className="font-bold text-xl">
            {value ?? '---'}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
